// extracted by mini-css-extract-plugin
export default {"container":"DynamicContent_container__oFB9M"};